import { render, staticRenderFns } from "./assign-tenants-modal.vue?vue&type=template&id=33bbd458&scoped=true&"
import script from "./assign-tenants-modal.vue?vue&type=script&lang=tsx&"
export * from "./assign-tenants-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./assign-tenants-modal.vue?vue&type=style&index=0&id=33bbd458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbd458",
  null
  
)

export default component.exports